import htmx from 'htmx.org'
htmx.config.allowEval = false
htmx.config.selfRequestsOnly = true
htmx.config.scrollBehavior = 'instant'
window.htmx = htmx
